(() => {
  const ROOT_CLASS = 'nh-product-template';
  document.documentElement.classList.add(ROOT_CLASS);

  const preparePage = () => {
    const productDetails = document.querySelector('[data-testid="product-information-details"]');
    if (productDetails && !document.getElementById('nh-buy')) {
      productDetails.id = 'nh-buy';
    }

    document.querySelectorAll('[data-nh-scroll-buy]').forEach((link) => {
      if (link.dataset.nhBound === 'true') return;
      link.dataset.nhBound = 'true';
      link.addEventListener('click', (event) => {
        const target = document.getElementById('nh-buy') || productDetails;
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        window.setTimeout(() => {
          const focusTarget = target.querySelector('input, select, button, a[href]');
          focusTarget?.focus({ preventScroll: true });
        }, 450);
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', preparePage, { once: true });
  } else {
    preparePage();
  }

  document.addEventListener('shopify:section:load', preparePage);
})();
